import { connect } from 'react-redux';
import { Draggable } from './Draggable';
import * as PropType from 'prop-types';

export class DraggableWithKeyboard extends Draggable {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      isSelected: false
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.initializeKeyboardSupport();
  }

  handleKeyDown = event => {
    const { allowDrag, allowTap } = this.props;
    const canHandle = allowDrag || allowTap;
    if (!canHandle) return;
    if (event.key === 'Enter') {
      if (allowTap) {
        this.handleTap();
      } else if (!allowTap && allowDrag) {
        this.setState({ isSelected: !this.state.isSelected });
        this.props.onSelect(event, this.state.isSelected);
      }
    }
  };

  initializeKeyboardSupport() {
    this.container.current.addEventListener('keydown', event => this.handleKeyDown(event));
  }
}

DraggableWithKeyboard.propTypes = {
  ...Draggable.propTypes,
  activityType: PropType.string,
  distance: PropType.number,
  level: PropType.number,
  mainContainerId: PropType.string
};

const mapStateToProps = state => ({
  sndCorrect: state.ui.sounds.common.correct || { play: () => {} },
  sndMoving: state.ui.sounds.common.swoosh || { play: () => {} },
  sndWrong: state.ui.sounds.common.wrong || { play: () => {} }
});

export default connect(mapStateToProps)(DraggableWithKeyboard);
